<script setup lang="ts">
import stringToColor from '@/string-to-color';
import Decimal from 'decimal.js';
import {onMounted, ref} from 'vue';


const props = defineProps<{
  tag: {
    tagName: string
    tagNumber: Decimal
  }
}>();

const color = ref<string>('');;

onMounted(async () => {
  color.value = await stringToColor(props.tag.tagName)
});

</script>

<template>
  <div
    class="compact-tag"
    :style="`background-color: ${color}`"
    :title="tag.tagName"
  >

  </div>
</template>

<style>
.compact-tag {
  color: hsl(var(--color-100));
  margin: 0 2px;
  border-radius: 3px;
  padding: 0 4px;
  white-space: nowrap;
  width: 14px;
  height: 14px;

  display: flex;
  align-items: center;
}
</style>